import { useState, useEffect, useRef } from 'react';
import Cookies from 'js-cookie';
import { useSelector, useDispatch } from 'react-redux';
import { recordActions } from '../../config/configuration/react';
import { useOfferCommon } from './useOfferCommon';

export const useSaleParameters = ({ sales, tradeStatus, offers }) => {
  const dispatch = useDispatch();
  const appLang = (Cookies.get('appLanguage') || 'en').toUpperCase();
  const isMounted = useRef(false);
  const recordId = useSelector((state) => state.reduxRecords?.currentRecord);
  const tradeData = useSelector((state) => state.reduxRecords.data[recordId])?.trade;
  const saleId = tradeData?.sale?.id;
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [merchantName, setMerchantName] = useState('');
  const [winner, setWinner] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [body, setBody] = useState('');
  const [previousWinnerState, setPreviousWinnerState] = useState(null);
  const [bodyCounterOffer, setBodyCounterOffer] = useState('');
  // const [currentSortAmount, setCurrentSortAmount] = useState('default');
  // const [currentSortCreatedAt, setCurrentSortCreatedAt] = useState('default');
  // const [currentSortedColumn, setCurrentSortedColumn] = useState('amount');
  const [counterOfferStatus, setCounterOfferStatus] = useState(null);
  const [counterOfferPending, setCounterOfferPending] = useState(null);
  const [isOpenCounterOffer, setIsOpenCounterOffer] = useState(false);
  const [offerAmount, setOfferAmount] = useState(null);
  const [offerId, setOfferId] = useState(null);
  const [userIdCounterOffer, setUserIdCounterOffer] = useState(null);
  const [counterOfferAmount, setCounterOfferAmount] = useState(null);
  const [inferiorCounterOffer, setInferiorCounterOffer] = useState(null);
  const [openRefuseOffersPopup, setOpenRefuseOffersPopup] = useState(false);

  const getAmount = (a) => a.offer.amount;
  const getDate = (a) => a.offer.createdAt;

  const { sortTypes, onSortChange, sortFunction, isFinished, currentSortAmount, currentSortCreatedAt } = useOfferCommon(
    { saleStatus: tradeStatus, getAmount, getDate },
  );
  const toggleRefuseOffersPopup = () => setOpenRefuseOffersPopup(!openRefuseOffersPopup);
  useEffect(() => {
    if (offers.length > 0) {
      offers.forEach((offer) => {
        if (offer.is_winner || offer.counter_offer?.is_winner) {
          setWinner(offer);
          setMerchantName(`${offer.user.first_name} ${offer.user.last_name}`);
        }
      });
      if (
        offers?.find((o) => o?.counter_offer?.is_accepted === true) ||
        offers?.find((o) => o?.counter_offer?.amount > 0 && o?.counter_offer?.is_accepted === null)
      ) {
        setCounterOfferStatus(true);
      } else {
        setCounterOfferStatus(false);
      }
      if (offers?.find((o) => o.counter_offer?.is_accepted === null)) {
        setCounterOfferPending(true);
      } else {
        setCounterOfferPending(false);
      }
    }
  }, [offers]);

  // const sortTypes = {
  //   amount: {
  //     down: {
  //       icon: faSortDown,
  //       fn: (a, b) => a.offer.amount - b.offer.amount,
  //     },
  //     up: {
  //       icon: faSortUp,
  //       fn: (a, b) => b.offer.amount - a.offer.amount,
  //     },
  //     default: {
  //       icon: faSort,
  //       fn: (a) => a,
  //     },
  //   },
  //   lastOfferCreatedAt: {
  //     down: {
  //       icon: faSortDown,
  //       fn: (a, b) => moment(a.offer.createdAt) - moment(b.offer.createdAt),
  //     },
  //     up: {
  //       icon: faSortUp,
  //       fn: (a, b) => moment(b.offer.createdAt) - moment(a.offer.createdAt),
  //     },
  //     default: {
  //       icon: faSort,
  //       fn: (a) => a,
  //     },
  //   },
  // };

  // const sortTarget = currentSortedColumn === 'amount' ? currentSortAmount : currentSortCreatedAt;
  // const sortFunction = sortTypes[currentSortedColumn][sortTarget].fn;

  const setloadingStatus = (res) => {
    if (isMounted.current) return;
    setLoading(res);
  };

  const setErrorStatus = (res) => {
    if (isMounted.current) return;
    setError(res);
  };

  const validateBtn = 'submit';
  const cancelBtn = 'cancel';

  const toggle = () => {
    setBody('');
    setIsOpen(!isOpen);
  };

  const toggleCounterOffer = () => {
    setUserIdCounterOffer('');
    setBodyCounterOffer('');
    setIsOpenCounterOffer(!isOpenCounterOffer);
    setCounterOfferAmount(null);
    setInferiorCounterOffer(false);
  };

  const handleCancel = () => {
    toggle();
    setWinner(previousWinnerState);
  };

  const handlePutWinner = async () => {
    let data = {};
    let offerIdToUpdate = {};
    if (winner) {
      data = { is_winner: true };
      offerIdToUpdate = winner.id;
    } else {
      try {
        if (
          offers.filter((o) => o.id === Object.keys(previousWinnerState)[0])[0]?.counter_offer &&
          offers.filter((o) => o.id === Object.keys(previousWinnerState)[0])[0]?.counter_offer?.is_accepted
        ) {
          const {
            counterOffer: { uuid },
          } = offers.filter((o) => o.id === Object.keys(previousWinnerState)[0])[0].offer;
          const { id } = offers.filter((o) => o.id === Object.keys(previousWinnerState)[0])[0].user;
          await dispatch(recordActions.putCounterOffer(uuid, id, false, 'stock'));
        }
      } catch (e) {
        console.log('error ', e);
      }
      data = { is_winner: false };
      offerIdToUpdate = previousWinnerState.id;
    }
    toggle();
    // const res = await dispatch(recordActions.putSales(sales?.id, data));
    const res = await dispatch(recordActions.putOffer(offerIdToUpdate, data));
    if (res?.id) {
      await dispatch(recordActions.getOffersApi({ type: 'stock', setloadingStatus, setErrorStatus }));
    }
  };

  const handleSendCounterOffer = async () => {
    try {
      if (counterOfferAmount !== null && counterOfferAmount > offerAmount) {
        await dispatch(
          recordActions.postCounterOffer(counterOfferAmount, offerId, userIdCounterOffer, sales.id, 'stock'),
        );
        toggleCounterOffer();
      } else {
        setInferiorCounterOffer(true);
      }
    } catch (e) {
      toggleCounterOffer();
      console.log('error while creating a counter offer ', e);
    }
  };

  const changeCounterOfferAmount = (e) => {
    setCounterOfferAmount(e.target.value);
  };

  const onChangeWinner = (e, i) => {
    setPreviousWinnerState(winner);
    if (e.target.checked) {
      setWinner(i);
      setIsOpen(true);
      setMerchantName(`${i.user.first_name} ${i.user.last_name}`);
    } else {
      setIsOpen(true);
      setWinner(null);
    }
  };

  // const onSortChange = (sortColumnParam) => {
  //   let nextSort;
  //   if (sortColumnParam === 'amount') {
  //     if (currentSortAmount === 'down') nextSort = 'up';
  //     else if (currentSortAmount === 'up') nextSort = 'default';
  //     else if (currentSortAmount === 'default') nextSort = 'down';
  //     setCurrentSortAmount(nextSort);
  //     setCurrentSortCreatedAt('default');
  //   } else if (sortColumnParam === 'lastOfferCreatedAt') {
  //     if (currentSortCreatedAt === 'down') nextSort = 'up';
  //     else if (currentSortCreatedAt === 'up') nextSort = 'default';
  //     else if (currentSortCreatedAt === 'default') nextSort = 'down';
  //     setCurrentSortCreatedAt(nextSort);
  //     setCurrentSortAmount('default');
  //   }
  //   setCurrentSortedColumn(sortColumnParam);
  // };
  const onChangeCounterOfferDetails = (offer) => {
    setOfferId(offer.id);
    setOfferAmount(offer.amount);
    setUserIdCounterOffer(offer.user.id);
    setIsOpenCounterOffer(true);
  };
  const handleCancelCounterOffer = () => {
    toggleCounterOffer();
  };

  const handleRefuseAllOffers = async () => {
    try {
      setLoading(true);
      await setOpenRefuseOffersPopup(false);
      await dispatch(recordActions.refuseAllOffers(recordId, saleId));

      await Promise.all([dispatch(recordActions.getSale()), dispatch(recordActions.fetchStockOffers(recordId))]);

      setLoading(false);
    } catch (e) {
      console.log(e.message);
      setLoading(false);
    }
  };

  return {
    appLang,
    isFinished,
    error,
    loading,
    isMounted,
    validateBtn,
    cancelBtn,
    sortFunction,
    toggle,
    handleCancel,
    handlePutWinner,
    onChangeWinner,
    onSortChange,
    setWinner,
    setMerchantName,
    setBody,
    body,
    merchantName,
    winner,
    isOpen,
    currentSortAmount,
    currentSortCreatedAt,
    sortTypes,
    counterOfferStatus,
    onChangeCounterOfferDetails,
    isOpenCounterOffer,
    offerAmount,
    counterOfferAmount,
    setBodyCounterOffer,
    bodyCounterOffer,
    changeCounterOfferAmount,
    toggleCounterOffer,
    handleCancelCounterOffer,
    handleSendCounterOffer,
    inferiorCounterOffer,
    counterOfferPending,
    tradeData,
    openRefuseOffersPopup,
    setOpenRefuseOffersPopup,
    toggleRefuseOffersPopup,
    handleRefuseAllOffers,
    saleId,
  };
};
